
import { Component } from "vue-property-decorator"
import NichtGueltig from "../custom/NichtGueltig.vue"
import TerminQrcodeLogic from "@/logic/bestellung_neu/termin_qrcode_logic"
import { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import { BuchungBestellart } from "mangdto"

@Component({ components: { NichtGueltig } })
export default class TerminQrCode extends mixins(Calculator) {
  logic: TerminQrcodeLogic = null

  BuchungBestellart = BuchungBestellart

  buchungsartWaehlen() {
    this.logic.buchungsartWaehlen()
  }

  tischBuchen() {
    this.logic.tischBuchen()
  }

  mounted() {
    this.logic = new TerminQrcodeLogic()
    this.logic.init(this.$route.params.id)
  }
}
